// Search bar toggle
(function () {
  var btn = document.querySelector('[data-search-toggle]');
  var bar = document.getElementById('search-bar');
  if (!btn || !bar) return;
  btn.addEventListener('click', function () {
    var open = bar.hasAttribute('hidden');
    if (open) { bar.removeAttribute('hidden'); bar.querySelector('input').focus(); }
    else { bar.setAttribute('hidden', ''); }
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();

// Hero carousel: auto-advance, arrows, dots, pause. Respects reduced motion.
(function () {
  var root = document.querySelector('[data-carousel]');
  if (!root) return;
  var slides = root.querySelectorAll('.slide'), dots = root.querySelectorAll('.dot');
  var i = 0, timer = null, paused = false;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
  }
  function start() { stop(); if (!paused && !reduced) timer = setInterval(function () { show(i + 1); }, 7000); }
  function stop() { if (timer) clearInterval(timer); timer = null; }
  root.querySelector('[data-next]').addEventListener('click', function () { show(i + 1); start(); });
  root.querySelector('[data-prev]').addEventListener('click', function () { show(i - 1); start(); });
  dots.forEach(function (d) { d.addEventListener('click', function () { show(+d.dataset.dot); start(); }); });
  var pb = root.querySelector('[data-pause]');
  pb.addEventListener('click', function () { paused = !paused; pb.innerHTML = paused ? '&#9654;' : '&#10074;&#10074;'; pb.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); paused ? stop() : start(); });
  root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
  show(0); start();
})();